import React from 'react';
import { Button } from 'components/ui/form';
import { Textarea, Input } from 'components/ui/formik';
import styles from './send-email.module.scss';

const SendEmail = ({ onSubmit, isValid }) => (
  <form onSubmit={onSubmit} autoComplete="off">
    <div className={styles.changePassword}>
      <div className={styles.name}>Отправить уведомление</div>
      <div className={styles.fields}>
        <div className={styles.field}>
          <Input
            label="Тема сообщения"
            name="subject"
            type="text"
            placeholder="Введите тему сообщения"
          />
        </div>
        <div className={styles.field}>
          <Textarea
            label="Текст письма"
            name="text"
            type="text"
            placeholder="Введите текст письма"
          />
        </div>
      </div>
    </div>
    <Button
      type="submit"
      color="lightgray"
      disabled={!isValid}
    >
      Отправить сообщение
    </Button>
  </form>
);

export default SendEmail;
